const department = {
  DEPARTMENT: 'DEPARTMENT',
  DEPARTMENTS: 'DEPARTMENTS',
  DEPARTMENTSGROUP: 'DEPARTMENTSGROUP',
  DEPARTMENTSGROUPS: 'DEPARTMENTSGROUPS',
  SINGLE_GROUP_GET: 'SINGLE_GROUP_GET'
}
export { department }
